module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-texte__colorbar",
    class: 'ksm-texte__colorbar--' + _vm.modus.id
  }), _vm._v(" "), _c('keep-alive', [_c(_vm.modus.id, {
    tag: "component",
    staticClass: "ksm-flex-1",
    attrs: {
      "viewKey": _vm.viewKey
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus_toolbar",
    attrs: {
      "slot": "modusindex-toolbar"
    },
    slot: "modusindex-toolbar"
  }, [(_vm.modus.id !== 'kompositionsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.merzId),
      expression: "selectedUrlparmas.merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s(merz.name.trim().replace(/^Merz/, 'Merz ')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.seiteIdx),
      expression: "selectedUrlparmas.seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeSeite]
    }
  }, _vm._l((_vm.seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "-2px",
      "visibility": "hidden"
    }
  }, [_c('select', [_c('option', [_vm._v("Meine Komposition 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-navigation"
  }, _vm._l((_vm.modusData.modusItems), function(it, i) {
    return _c('div', {
      key: 'nav' + i,
      staticClass: "ksm-texte__modus-navItem",
      class: 'ksm-modus__navi--' + it.id + (it.id == _vm.modus.id ? ' active' : ''),
      attrs: {
        "title": it.label
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg(it.img))
      },
      on: {
        "click": function($event) {
          return _vm.changeModus(it)
        }
      }
    })
  }), 0), _vm._v(" "), (_vm.modus.id == 'untersuchungsmodus') ? _c('div', {
    staticClass: "ksm-transparent-slider"
  }, [_c('div', [_c('input', {
    staticClass: "ksm-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "slider1",
      "type": "range",
      "min": "0",
      "max": "100%",
      "step": "1"
    },
    domProps: {
      "value": _vm.transparenzValue
    },
    on: {
      "input": _vm.changeTransparent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "__text"
  }, [_c('div', [_vm._v("0%")]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-xy-center"
  }, [_vm._v("Transparenz")]), _vm._v(" "), _c('div', [_vm._v("100%")])])]) : _vm._e(), _vm._v(" "), (_vm.modus.id == 'vergleichsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.b_merzId),
      expression: "selectedUrlparmas.b_merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "b_merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.b_changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s(merz.name.trim().replace('Merz', 'Merz ')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.b_seiteIdx),
      expression: "selectedUrlparmas.b_seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "b_seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.b_changeSeite]
    }
  }, _vm._l((_vm.b_seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.modus.id == 'kompositionsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.merzId),
      expression: "selectedUrlparmas.merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s('Merz ' + merz.name.replace('Merz', '').trim()))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.seiteIdx),
      expression: "selectedUrlparmas.seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeSeite]
    }
  }, _vm._l((_vm.seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cf71b54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modus/ModusIndex.vue
// module id = 1989
// module chunks = 1